import { CHANGE_SCREEN_TYPE } from './action-types'
import { DESKTOP, TABLET, MOBILE } from './screen-types'

const changeScreenResolutionToDesktop = () => ({
  type: CHANGE_SCREEN_TYPE,
  payload: DESKTOP,
})
const changeScreenResolutionToTablet = () => ({
  type: CHANGE_SCREEN_TYPE,
  payload: TABLET,
})

const changeScreenResolutionToMobile = () => ({
  type: CHANGE_SCREEN_TYPE,
  payload: MOBILE,
})

export {
  changeScreenResolutionToDesktop,
  changeScreenResolutionToTablet,
  changeScreenResolutionToMobile,
}
